import React, { useEffect, useState } from "react";
import LoadingSpinner from "@/components/loading-spinner/LoadingSpinner";
import ContactDetailsBox from "../contact-details-box/ContactDetailsBox";
import styles from "./DecisionTree.module.scss";
import { getSolutionContactDetailsByTag } from "../../utils/data/getContactDetails";
import { useDecisionTreeLocation } from "@/hooks";
import { useFeatureFlag } from "@/context/FeatureFlagContext";

function SolutionViewContactDetails({ contactDetailsTag }) {
  const showNewProminentLiveChat = useFeatureFlag("show_new_prominent_live_chat");

  const [contactConfig, setContactConfig] = useState(null);
  const location = useDecisionTreeLocation();

  useEffect(() => {
    getSolutionContactDetailsByTag(contactDetailsTag).then(config => setContactConfig(config));
  }, []);

  return (
    <div className={styles.solutionViewContactDetailsContainer}>
      {!contactConfig && <LoadingSpinner />}
      {contactConfig && (
        <ContactDetailsBox
          newDesign={!showNewProminentLiveChat}
          title={showNewProminentLiveChat ? "We're here to help" : "Do you still need help?"}
          fields={[
            { name: "phone", key: "number" },
            { name: "chat", key: "channel" },
          ].map(obj =>
            contactConfig[obj.name]
              ? {
                  name: obj.name,
                  content: contactConfig[obj.name][obj.key],
                }
              : null,
          )}
          solutionId={contactConfig.solution}
          location={location}
          otherContactDetails={contactConfig}
          viewContactDetails
        />
      )}
    </div>
  );
}

export default SolutionViewContactDetails;
